/* eslint-disable import/prefer-default-export */
import axios from '../axios';
import { useMutation, useQuery } from 'react-query';

// Get Users in queue for a charger
export function useQueueUsersForCharger(cpid) {
  return useQuery(
    ['corporateQueue', cpid],
    () =>
      axios.get(`/corporate/corporateQueue/${cpid}`).then((result) => {
        return result?.data;
      }),
    { enabled: !!cpid },
  );
}

// Add User to Queue
export function useAddUserToQueueMutation() {
  return useMutation(
    (corporateUser) => {
      return axios.post(`/corporate/corporateQueue`, corporateUser);
    },
    {
      onSuccess: (res) => ({ error: res.error, data: res.data }),
      onError: (err) => {
        return { data: err.response.data };
      },
    },
  );
}

// Remove User from queue
// export function useRemoveUserFromQueueOfCharger(qid) {
//   return useQuery(
//     ['removeFromQueue', qid],
//     () =>
//       axios.delete(`/corporate/corporateQueue/${qid}`).then((result) => {
//         return result?.data;
//       }),
//     { enabled: !!qid },
//   );
// }

export function useRemoveUserFromQueueOfCharger(qid) {
  return useQuery(
    ['removeFromQueue', qid],
    () =>
      // axios.delete(`/corporate/corporateQueue/${qid}`).then((result) => {
      axios.post(`/corporate/leaveQueue/${qid}`).then((result) => {
        return result?.data;
      }),
    { enabled: !!qid },
  );
}
